import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e8a272c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body-max-width-no-padding" }
const _hoisted_2 = { class: "mock-footer relative" }
const _hoisted_3 = { class: "bottom-screen" }
const _hoisted_4 = { class: "footer-menu relative overflow-hidding" }
const _hoisted_5 = { style: {"max-width":"500px","margin":"auto"} }
const _hoisted_6 = { style: {"overflow":"hidden"} }
const _hoisted_7 = {
  class: "flex-center",
  style: {"float":"left","display":"flex"}
}
const _hoisted_8 = { class: "total-label fs-17 fw-500 fc-52684F mr-10" }
const _hoisted_9 = {
  class: "price-label fs-17 fw-500 ml-auto",
  style: {"text-align":"right"}
}
const _hoisted_10 = {
  class: "price-label right fs-16 fw-500 fc-9A9A9A",
  style: {"text-decoration":"line-through"}
}
const _hoisted_11 = { style: {"float":"right","display":"flex"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin":"auto"} }, "ชำระเงิน", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  id: "package_for_you",
  class: "body-max-width"
}
const _hoisted_15 = { class: "body-max-width" }
const _hoisted_16 = { class: "pt-14 mt-36" }
const _hoisted_17 = { class: "flex-center" }
const _hoisted_18 = {
  key: 0,
  class: "checked"
}
const _hoisted_19 = { class: "package-container" }
const _hoisted_20 = { class: "flex-center relative" }
const _hoisted_21 = { class: "mr-auto flex-center flex-warp title" }
const _hoisted_22 = { class: "checkbox mr-16" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "checked"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "9",
  height: "6",
  viewBox: "0 0 9 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.66952 0.246055C8.51098 0.0884582 8.29653 0 8.07298 0C7.84944 0 7.63498 0.0884582 7.47644 0.246055L4.43875 3.24144L1.44337 0.246055C1.28483 0.0884582 1.07037 0 0.846829 0C0.623287 0 0.408828 0.0884582 0.250291 0.246055C0.170982 0.324716 0.108033 0.418302 0.0650749 0.521413C0.0221168 0.624525 0 0.735122 0 0.846824C0 0.958527 0.0221168 1.06912 0.0650749 1.17224C0.108033 1.27535 0.170982 1.36893 0.250291 1.44759L3.83798 5.03529C3.91664 5.11459 4.01023 5.17754 4.11334 5.2205C4.21645 5.26346 4.32705 5.28558 4.43875 5.28558C4.55045 5.28558 4.66105 5.26346 4.76416 5.2205C4.86728 5.17754 4.96086 5.11459 5.03952 5.03529L8.66952 1.44759C8.74883 1.36893 8.81178 1.27535 8.85474 1.17224C8.8977 1.06912 8.91981 0.958527 8.91981 0.846824C8.91981 0.735122 8.8977 0.624525 8.85474 0.521413C8.81178 0.418302 8.74883 0.324716 8.66952 0.246055Z",
    fill: "black"
  })
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 0,
  class: "line-package mt-18"
}
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = { class: "checkbox mt-10" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "checked"
}
const _hoisted_33 = { class: "body mt-4" }
const _hoisted_34 = { class: "pricing Avenir fs-14 fw-500 mt-10" }
const _hoisted_35 = {
  key: 0,
  class: "pricing-sale-mobile"
}
const _hoisted_36 = { class: "fc-C31212 ml-auto" }
const _hoisted_37 = { class: "sale" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "package mt-22" }
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-center border-bottom-line pb-14\" data-v-6e8a272c><div class=\"fs-18 fw-500\" data-v-6e8a272c>Coupon</div><div class=\"ml-auto flex-center cursor-pointer\" data-v-6e8a272c><div class=\"fs-14 fw-500 fc-B4B4B4 mr-10\" data-v-6e8a272c>Apply coupon</div><svg width=\"7\" height=\"11\" viewBox=\"0 0 7 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6e8a272c><path d=\"M0.23013 10.7699C-0.0767102 10.463 -0.0767102 9.96554 0.23013 9.6587L4.38883 5.5L0.23013 1.3413C-0.0767106 1.03446 -0.0767106 0.536971 0.23013 0.230131C0.53697 -0.0767098 1.03446 -0.0767098 1.3413 0.230131L6.05558 4.94442C6.36242 5.25126 6.36242 5.74874 6.05558 6.05558L1.3413 10.7699C1.03446 11.0767 0.536971 11.0767 0.23013 10.7699Z\" fill=\"#B4B4B4\" data-v-6e8a272c></path></svg></div></div><div class=\"fs-18 fw-500 mt-22\" data-v-6e8a272c>Payment Methods</div>", 2)
const _hoisted_42 = { class: "mt-22" }
const _hoisted_43 = { class: "flex-center mb-10" }
const _hoisted_44 = { class: "checkbox-container mr-20" }
const _hoisted_45 = {
  key: 0,
  class: "checked"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-16 fc-2B2A2A" }, "Credit/Debit", -1))
const _hoisted_47 = { class: "expend-package showing border-bottom-line pl-20" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "image" }
const _hoisted_50 = ["src"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "XXXX", -1))
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-center select-payment\" data-v-6e8a272c><div class=\"image\" data-v-6e8a272c><div class=\"checkbox-container flex-mid fc-FFFFFF\" data-v-6e8a272c><svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6e8a272c><path d=\"M6.81283 1.6665C6.81283 1.21777 6.44906 0.854004 6.00033 0.854004C5.55159 0.854004 5.18783 1.21777 5.18783 1.6665V5.18734L1.66699 5.18734C1.21826 5.18734 0.854492 5.55111 0.854492 5.99984C0.854492 6.44857 1.21826 6.81234 1.66699 6.81234H5.18783V10.3332C5.18783 10.7819 5.55159 11.1457 6.00033 11.1457C6.44906 11.1457 6.81283 10.7819 6.81283 10.3332V6.81234H10.3337C10.7824 6.81234 11.1462 6.44857 11.1462 5.99984C11.1462 5.55111 10.7824 5.18734 10.3337 5.18734L6.81283 5.18734V1.6665Z\" fill=\"white\" data-v-6e8a272c></path></svg></div></div><div class=\"label\" data-v-6e8a272c>Add new card</div></div>", 1)
const _hoisted_53 = { class: "mt-22" }
const _hoisted_54 = { class: "flex-center mb-10" }
const _hoisted_55 = { class: "checkbox-container mr-20" }
const _hoisted_56 = {
  key: 0,
  class: "checked"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-16 fc-2B2A2A" }, "Mobile Banking", -1))
const _hoisted_58 = { class: "expend-package showing border-bottom-line pl-20" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://media-exp1.licdn.com/dms/image/C510BAQElNZUFumis3Q/company-logo_200_200/0/1519912092504?e=2147483647&v=beta&t=XV8IDCX3ysr66OYF7HNdHJxT-l-zDnKhdnEAU2GEfXA",
    alt: "",
    style: {"border-radius":"3rem"}
  })
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Siam commercial bank", -1))
const _hoisted_61 = [
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www.whatphone.net/wp-content/uploads/2018/10/new-k-plus-logo.png",
    alt: "",
    style: {"border-radius":"3rem"}
  })
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Kasikorn", -1))
const _hoisted_64 = [
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = { class: "checkbox-container mr-20" }
const _hoisted_66 = {
  key: 0,
  class: "checked"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-16 fc-2B2A2A" }, "QR", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20rem"} }, " ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("total")), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.numberWithCommas(1000)) + " " + _toDisplayString(_ctx.$t("baht")), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.numberWithCommas(1000)) + " " + _toDisplayString(_ctx.$t("baht")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkDate && _ctx.checkDate(...args))),
                    class: "payment-button right"
                  }, _hoisted_13)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_Header, {
        back: "/home",
        title: _ctx.$t('payment')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectAllPackage())),
              class: "checkbox-container ml-auto"
            }, [
              (_ctx.selected_all)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectAllPackage())),
              class: "fc-696969 fs-14 fw-500 ml-10"
            }, " Select all ")
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageList, (value, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "package mt-22",
              key: value.id
            }, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.selectPackage(index, value.id)),
                      class: "checkbox-container"
                    }, [
                      (value.select)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_23)
                  ]),
                  _createElementVNode("div", null, _toDisplayString(value.title), 1)
                ]),
                _createElementVNode("div", {
                  class: "icon-arrow relative flex-mid",
                  onClick: ($event: any) => (value.statusShow = !value.statusShow)
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`arrow-show mt-2 ${value.statusShow ? 'show' : ''}`)
                  }, _hoisted_27, 2)
                ], 8, _hoisted_25)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(`expend-package ${value.statusShow ? 'showing' : ''}`)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.package, (val) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "sub-package",
                    key: val.id
                  }, [
                    (value.statusShow)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.selectSubPackage(index, val.id)),
                          class: "checkbox-container"
                        }, [
                          (val.select)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_31)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(val.include, (descrition, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i + val.id,
                            class: "include-label mt-4"
                          }, " • " + _toDisplayString(descrition), 1))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        (val.salePrice)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.numberWithCommasLine(val.price - val.salePrice)), 1),
                              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.numberWithCommasLine(val.price)), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.numberWithCommasLine(val.price)), 1))
                      ])
                    ])
                  ]))
                }), 128))
              ], 2)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  (_ctx.paymentTypeSelected == 'credit-card')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_46
              ]),
              _createElementVNode("div", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardList, (card) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: card.id,
                    class: _normalizeClass(`flex-center select-payment ${
                  _ctx.paymentIDSelected == card.id ? 'selected' : ''
                }`),
                    onClick: ($event: any) => (_ctx.selectPayment('credit-card', card.id))
                  }, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("img", {
                        src: card.imageURL,
                        alt: ""
                      }, null, 8, _hoisted_50)
                    ]),
                    _hoisted_51
                  ], 10, _hoisted_48))
                }), 128)),
                _hoisted_52
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  (_ctx.paymentTypeSelected == 'mobile-banking')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_57
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectPayment('mobile-banking', 'scb'))),
                  class: _normalizeClass(`flex-center select-payment ${
                  _ctx.paymentIDSelected == 'scb' ? 'selected' : ''
                }`)
                }, _hoisted_61, 2),
                _createElementVNode("div", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectPayment('mobile-banking', 'kbank'))),
                  class: _normalizeClass(`flex-center select-payment ${
                  _ctx.paymentIDSelected == 'kbank' ? 'selected' : ''
                }`)
                }, _hoisted_64, 2)
              ]),
              _createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectPayment('qr', ''))),
                class: "flex-center mb-10 mt-22"
              }, [
                _createElementVNode("div", _hoisted_65, [
                  (_ctx.paymentTypeSelected == 'qr')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_67
              ])
            ])
          ])
        ]),
        _hoisted_68
      ])
    ])
  ], 64))
}